window.popper = function (options) {
    let settings = {
        trigger: null,
        contentEl: null,
        popperDesktopPosition: options.popperDesktopPosition !== undefined ? options.popperDesktopPosition : "top",
        disableDesktop: false
    }

    if (typeof options.trigger === 'object') {
        if (options.trigger.length) {
            settings.trigger = options.trigger;
        } else {
            console.error('trigger ' + options.trigger.selector + ' does not exist');
            return;
        }
    } else {
        throw new Error('infopopper - invalid trigger selector' + options.trigger);
        return;
    }

    if (typeof options.contentEl === 'object') {
        if (options.contentEl.length) {
            settings.contentEl = options.contentEl.clone(true);
        } else {
            console.error('title element ' + options.contentEl + ' does not exist');
            return;
        }
    } else if (typeof options.contentEl === 'string') {
        settings.contentEl = options.contentEl;
    } else {
        settings.contentEl = 'Default content';
    }

    const popper_markup = '<div class="popper-dropdown">' +
        '<div class="popper-dropdown__content"></div>' +
        '</div>';
    const popper = $(popper_markup);
    const popperContent = popper.find('.popper-dropdown__content');
    const desktopMinScreenWidth = 1025;
    const positions = [
        "top",
        "right",
        "bottom",
        "left"
    ];
    let popperPos = {
        "top": null,
        "left": null
    };

    popperContent.html(settings.contentEl);

    if (!positions.includes(settings.popperDesktopPosition) && window.innerWidth >= desktopMinScreenWidth) {
        // throw new Error('infopopper - invalid desktop direction value');
        console.error('infopopper - invalid desktop direction value. Direction was set to base value: "top"');
        settings.popperDesktopPosition = "top"
    }

    function popperPosition() {
        popperPos.top = (settings.trigger.offset().top - (popper.offset().top - popper.get(0).offsetTop));
        popperPos.left = settings.trigger.offset().left;

        switch (settings.popperDesktopPosition) {
            case 'top':
                popperPos.top = popperPos.top - popper.height();
                popperPos.left = popperPos.left - (popper.width() / 2) + ($(settings.trigger).width() / 2);
                break;
            case 'right':
                popperPos.left = popperPos.left + $(settings.trigger).width();
                break;
            case 'bottom':
                popperPos.top = popperPos.top + $(settings.trigger).height();
                popperPos.left = popperPos.left - (popper.width() / 2) + ($(settings.trigger).width() / 2);
                break;
            case 'left':
                popperPos.left = popperPos.left - popper.width();
                break;
        }

        popper.css({
            'top': popperPos.top + 'px',
            'left': popperPos.left + 'px'
        });
    }

    $(window).on('resize orientationchange rotate', function () {
        popperPosition();
    });

    settings.trigger.on('click', function (e) {
        e.preventDefault();
        
        if (settings.disableDesktop && window.innerWidth >= desktopMinScreenWidth) return false;
        popperPosition();
        popper.addClass('show');
    });

    function hidepopper() {
        popper.removeClass('show');
    }

    $(document).on('mouseup', function (e) {
        let block = settings.trigger;
        if (!block.is(e.target)
            && block.has(e.target).length === 0) {
            hidepopper()
        }
    });

    $('body').append(popper);
}

$(document).ready(function(){
    if ( $('.popper').length > 0 ) {
        $('.popper').each(function(){
            let self = $(this);

            popper({
                trigger: self.children('button'),
                contentEl: self.children('.popper-menu'),
                tooltipDesktopPosition: 'top',
            });
        })
    }
})